import { render, staticRenderFns } from "./ExamPaperManage.vue?vue&type=template&id=5c0a81bd&scoped=true&"
import script from "./ExamPaperManage.vue?vue&type=script&lang=js&"
export * from "./ExamPaperManage.vue?vue&type=script&lang=js&"
import style0 from "./ExamPaperManage.vue?vue&type=style&index=0&id=5c0a81bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a81bd",
  null
  
)

export default component.exports